import { SettingType, AnalyticsTypes } from '../google-analytics';

export const GA_SET_CUSTOM_DIMENSION = '@@ANALYTICS/GA_SET_CUSTOM_DIMENSION';
export const GA_SET_CONTENT_GROUP = '@@ANALYTICS/GA_SET_CONTENT_GROUP';
export const GA_SET_PAGE_VIEW = '@@ANALYTICS/GA_SET_PAGE_VIEW';
export const GA_SEND_PAGE_VIEW = '@@ANALYTICS/GA_SEND_PAGE_VIEW';
export const GA_SET_EVENT = '@@ANALYTICS/GA_SET_EVENT';
export const GA_LINK_DOMAINS = '@@ANALYTICS/GA_LINK_DOMAINS';

const GoogleAnalyticsIds =
    process.env.NODE_ENV === 'production'
        ? {
              en: 'UA-2809147-1',
              es: 'UA-2809147-15',
          }
        : {
              en: 'UA-2809147-13',
              es: 'UA-2809147-13',
          };

export function setLinkedDomain({ domains }) {
    return {
        type: GA_LINK_DOMAINS,
        meta: {
            analytics: {
                type: AnalyticsTypes.LinkDomains,
                token: GoogleAnalyticsIds.en,
                domains,
            },
        },
        payload: {},
    };
}

export function triggerPageView() {
    return {
        type: GA_SEND_PAGE_VIEW,
        payload: {},
    };
}

export function triggerFingerprint(fingerprint, action) {
    return {
        type: '@ssr/fingerprint',
        meta: {
            analytics: {
                type: AnalyticsTypes.TrackEvent,
                category: 'Booking',
                action,
                data: {
                    Label: fingerprint,
                },
            },
        },
    };
}

export function setCustomDimension({ dimension, value }) {
    return {
        type: GA_SET_CUSTOM_DIMENSION,
        meta: {
            analytics: {
                type: AnalyticsTypes.SetDimension,
                value,
                index: dimension,
                settingType: SettingType.CustomDimension,
            },
        },
        payload: {},
    };
}

export function setContentGroup({ group, value }) {
    return {
        type: GA_SET_CONTENT_GROUP,
        meta: {
            analytics: {
                type: AnalyticsTypes.SetDimension,
                value,
                index: group,
                settingType: SettingType.ContentGroup,
            },
        },
        payload: {},
    };
}

export function setEvent({ category, action }) {
    return {
        type: GA_SET_EVENT,
        meta: {
            analytics: {
                type: AnalyticsTypes.TrackEvent,
                category,
                action,
            },
        },
        payload: {},
    };
}

export function sendPageView(data) {
    return {
        type: GA_SET_PAGE_VIEW,
        meta: {
            analytics: {
                type: AnalyticsTypes.ChangePageView,
                ...data,
            },
        },
    };
}
